/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.arrow-left\":[\"Pil som peker mot venstre\"]}");